module.exports = __webpack_public_path__ + "img/service_web_solutions_5_mob.a55daf04.jpg";